export const PROGRAM_MODULES = Object.freeze({
  NUMBER: 1,
  HEALTH: 2,
  WAREHOUSE: 7,
  NUTRITION: 8
});

export const PROGRAM_MODULE_LABELS = Object.freeze({
  [PROGRAM_MODULES.NUMBER]: "Номерной фонд",
  [PROGRAM_MODULES.HEALTH]: "Лечебная часть",
  [PROGRAM_MODULES.WAREHOUSE]: "Склад",
  [PROGRAM_MODULES.NUTRITION]: "Питание"
});

export const hasLicensedModule = (license, moduleNumber) =>
  Array.isArray(license?.modules) && license.modules.includes(moduleNumber);
